import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import CampaignEditorPage from "@/app/CampaignEditorPage";

const campaignSearchSchema = z.object({
  feedback: z.literal("open").optional(),
});

export const Route = createFileRoute("/campaign/$shortId/")({
  validateSearch: campaignSearchSchema,
  component: CampaignEditorPage,
});
